import type {Expand} from '../../types';

import {omitExpand} from '../../utils/expand';
import {paymentExpandCommon} from '../expand';

const paymentExpand = omitExpand(paymentExpandCommon, ['refund_ids']);

export const refundExpandCommon: Expand = {
  refund: [
    ['refund_payment_id->refundPayment', null, paymentExpand],
    ['payment_id', null, paymentExpand],
  ],
};
